import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { MatButton } from '@angular/material/button';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: true,
    imports: [
        RouterLink,
        MatButton,
        MatMenuTrigger,
        MatIcon,
        MatMenu,
        MatMenuItem,
        RouterLinkActive,
    ],
})
export class HeaderComponent implements OnInit {
  constructor() {}

  ngOnInit() {}

  openRegister() {
    let url = 'https://register.broadfactor.com/cedente';
    let origin_campaign = localStorage.getItem('origin_campaign');
    let origin_lead = localStorage.getItem('origin_lead');
    if (origin_campaign && origin_campaign !== 'undefined') {
      url = url + '?origin_campaign=' + origin_campaign;
    }
    if (origin_lead && origin_lead !== 'undefined') {
      if (origin_campaign && origin_campaign !== 'undefined') {
        url = url + '&origin_lead=' + origin_lead;
      } else {
        url = url + '?origin_lead=' + origin_lead;
      }
    }

    window.open(url);
  }
}
